import { AlertCircle, X } from "lucide-react"

export default function SkippedFilesNotice({ skippedFiles, onDismiss }) {
    if (!skippedFiles || skippedFiles.length === 0) return null

    return (
        <div className="flex gap-2 bg-red-50 border border-red-200 p-4 rounded-md">
            <AlertCircle className="h-5 w-5 text-red-500 flex-shrink-0" />
            <div className="flex-1">
                <h4 className="font-semibold text-sm mb-1">
                    {skippedFiles.length} file{skippedFiles.length > 1 ? "s" : ""} will be skipped
                </h4>
                <p className="text-sm text-gray-700">
                    We could not read {skippedFiles.length > 1 ? "these files" : "this file"}, so
                    {skippedFiles.length > 1 ? " they" : " it"} will not be uploaded. Your other documents will be
                    uploaded normally. Please check the original {skippedFiles.length > 1 ? "files" : "file"} and try
                    again with a working copy.
                </p>
                <ul className="mt-2 space-y-1 max-h-[120px] overflow-auto text-sm text-gray-700">
                    {skippedFiles.map((file, index) => (
                        <li key={index}>
                            <span className="font-medium">{file.name}</span> — {file.reason}
                        </li>
                    ))}
                </ul>
            </div>
            {onDismiss && (
                <button onClick={onDismiss} className="p-1 text-gray-500 hover:text-gray-700 self-start">
                    <X className="h-4 w-4" />
                </button>
            )}
        </div>
    )
}
